"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const react_router_dom_1 = require("react-router-dom");
const schemaComponents_1 = require("@/schemaComponents");
const standard_1 = require("react-hook-schema/standard");
const shortcutHandler_1 = require("utils/shortcutHandler");
const react_2 = __importDefault(require("react"));
const hooks_1 = require("common/hooks");
const schema_1 = __importDefault(require("./schema"));
const function_client_1 = require("@/utils/function-client");
const models_hook_1 = require("app/models.hook");
const updateScript_1 = require("@/utils/updateScript");
const hooks_2 = require("@mantine/hooks");
const components_1 = require("utils/components");
const ScriptItemForm = ({ langId, projectId, segmentId, data, readOnly, accessorRef, updateRef, numberOfUnresolvedComment, onAction, splitMode, isLastElement, }) => {
    var _a, _b;
    const [toast, setToast] = (0, react_1.useState)({
        status: null,
        timer: null,
    });
    const [translationsCleared, setTranslationsCleared] = (0, react_1.useState)(false);
    const alert = (0, standard_1.useAlert)();
    const confirm = (0, standard_1.useConfirm)({ closeOnEnter: true });
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { data: projectData } = (0, models_hook_1.useProjectDoc)({ projectId });
    const [operationMode] = (0, hooks_1.useSessionStorage)("operationMode", undefined);
    const form = (0, react_hook_form_1.useForm)({
        defaultValues: Object.assign({}, data),
    });
    const { handleSubmit, control, formState, reset, getValues } = form;
    (0, react_1.useEffect)(() => {
        if (formState.isDirty) {
            setBlockNavigation(true);
        }
    }, [formState.isDirty]);
    (0, react_1.useEffect)(() => {
        reset(data);
        setTranslationsCleared(false);
    }, [updateRef, reset]);
    const errorModal = (0, standard_1.useErrorModal)();
    if (accessorRef) {
        accessorRef.current = {
            get: () => getValues(),
            set: (value) => reset(value),
        };
    }
    const save = (0, react_1.useCallback)((values, status, // null means "not started", undefined means "use user input"
    next) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d, _e, _f, _g;
        if (next && !isLastElement) {
            onAction === null || onAction === void 0 ? void 0 : onAction("next");
        }
        // Check if original text has been modified
        const isOriginalTextModified = values.text !== data.text;
        yield (0, updateScript_1.updateScript)({
            projectId,
            segmentId: values.segmentId,
            scriptId: values.scriptId,
            data: Object.assign(Object.assign({}, values), { tags: (_c = values.tags) === null || _c === void 0 ? void 0 : _c.filter((tag) => tag !== undefined), translations: isOriginalTextModified
                    ? {} // Reset all translations if original text was modified
                    : {
                        [langId]: (_e = (_d = values.translations) === null || _d === void 0 ? void 0 : _d[langId]) !== null && _e !== void 0 ? _e : "",
                    }, translationStatus: isOriginalTextModified
                    ? {} // Reset all translation statuses if original text was modified
                    : {
                        [langId]: status !== undefined
                            ? status
                            : (_f = values.translationStatus) === null || _f === void 0 ? void 0 : _f[langId],
                    }, translationIgnore: langId
                    ? { [langId]: (_g = values.translationIgnore) === null || _g === void 0 ? void 0 : _g[langId] }
                    : values.translationIgnore }),
        });
        // If original text was modified, immediately clear the translation fields
        if (isOriginalTextModified) {
            const clearedValues = Object.assign(Object.assign({}, values), { translations: {}, translationStatus: {} });
            reset(clearedValues);
            setTranslationsCleared(true);
        }
    }), [
        function_client_1.syncScriptSearchDocument,
        isLastElement,
        langId,
        projectId,
        segmentId,
        onAction,
        data.text,
        reset,
    ]);
    const isTranslationReadOnly = ((operationMode, translationStatus) => {
        if (operationMode === "translator") {
            if (translationStatus === "corrected") {
                return true;
            }
        }
        if (operationMode === "corrector") {
            if (!translationStatus) {
                return true;
            }
        }
        return false;
    })(operationMode, (_a = data.translationStatus) === null || _a === void 0 ? void 0 : _a[langId]);
    const handleSave = () => __awaiter(void 0, void 0, void 0, function* () {
        var _h;
        try {
            const values = getValues();
            const translationStatus = langId
                ? (_h = values.translationStatus) === null || _h === void 0 ? void 0 : _h[langId]
                : undefined;
            yield save(values, translationStatus, false);
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "Error while submitting script",
                userMessage: "テキスト情報の保存に失敗しました。この問題が繰り返す場合は管理者にお問い合わせください。",
            });
        }
    });
    const isShortcutSaving = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        isShortcutSaving.current = false;
    }, [data]);
    const parameter = (0, react_1.useMemo)(() => {
        var _a, _b;
        return ({
            schema: (0, schema_1.default)({
                langId,
                fixStatus: !!operationMode,
                projectId,
                segmentId,
                ignoredReferenceTranslationIds: (_a = projectData.ignoredReferenceTranslationIds) !== null && _a !== void 0 ? _a : [],
                scriptId: data.scriptId,
                additionalData: data.additionalData,
                isTextUpdated: data.isTextUpdated,
                operationMode,
                isTranslationReadOnly,
                autoSaveHandler: !isShortcutSaving.current
                    ? handleSubmit(handleSave)
                    : undefined,
                splitMode: splitMode,
                hasTranslation: !!((_b = data.translations) === null || _b === void 0 ? void 0 : _b[langId]),
            }),
            edit: (() => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (!langId)
                    return undefined;
                if (operationMode === "corrector") {
                    if (((_a = data.translationStatus) === null || _a === void 0 ? void 0 : _a[langId]) === "corrected") {
                        return {
                            title: "次へ",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "corrected", true);
                            }),
                        };
                    }
                    else if (((_b = data.translationStatus) === null || _b === void 0 ? void 0 : _b[langId]) === "translated") {
                        return {
                            title: isLastElement ? "校閲済みにする" : "校閲済みにして次へ",
                            confirm: "校閲済みにしますか?",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "corrected", true);
                            }),
                        };
                    }
                }
                else if (operationMode === "translator") {
                    if (((_c = data.translationStatus) === null || _c === void 0 ? void 0 : _c[langId]) !== "translated" &&
                        ((_d = data.translationStatus) === null || _d === void 0 ? void 0 : _d[langId]) !== "corrected") {
                        return {
                            title: isLastElement ? "翻訳済みにする" : "翻訳済みにして次へ",
                            confirm: "翻訳済みにしますか?",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "translated", true);
                            }),
                        };
                    }
                    else if (((_e = data.translationStatus) === null || _e === void 0 ? void 0 : _e[langId]) === "translated") {
                        return {
                            title: isLastElement ? "次へ" : "次へ",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "translated", true);
                            }),
                        };
                    }
                }
                else {
                    if (((_f = data.translationStatus) === null || _f === void 0 ? void 0 : _f[langId]) !== "translated" &&
                        ((_g = data.translationStatus) === null || _g === void 0 ? void 0 : _g[langId]) !== "corrected") {
                        return {
                            title: isLastElement ? "翻訳済みにする" : "翻訳済みにして次へ",
                            confirm: "翻訳済みにしますか?",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "translated", true);
                            }),
                        };
                    }
                    else if (((_h = data.translationStatus) === null || _h === void 0 ? void 0 : _h[langId]) === "translated") {
                        return {
                            title: isLastElement ? "校閲済みにする" : "校閲済みにして次へ",
                            confirm: "校閲済みにしますか?",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "corrected", true);
                            }),
                        };
                    }
                    else if (((_j = data.translationStatus) === null || _j === void 0 ? void 0 : _j[langId]) === "corrected") {
                        return {
                            title: "次へ",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "corrected", true);
                            }),
                        };
                    }
                }
                return undefined;
            })(),
            next: (() => {
                var _a, _b;
                if (!langId)
                    return undefined;
                const translationStatus = (_a = data.translationStatus) === null || _a === void 0 ? void 0 : _a[langId];
                if (operationMode === "corrector") {
                    if (!translationStatus) {
                        return {
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                if (!isLastElement) {
                                    onAction === null || onAction === void 0 ? void 0 : onAction("next");
                                }
                            }),
                        };
                    }
                    else if (translationStatus === "corrected") {
                        return {
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "corrected", true);
                            }),
                        };
                    }
                    else if (translationStatus === "translated") {
                        return {
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "corrected", true);
                            }),
                        };
                    }
                }
                // admin or corrector or no-permission
                if (operationMode === "translator") {
                    if (((_b = data.translationStatus) === null || _b === void 0 ? void 0 : _b[langId]) === "translated") {
                        return {
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "translated", true);
                            }),
                        };
                    }
                }
                if (!translationStatus) {
                    return {
                        handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                            yield save(values, "translated", true);
                        }),
                    };
                }
                else if (translationStatus === "corrected") {
                    return {
                        handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                            yield save(values, "corrected", true);
                        }),
                    };
                }
                else if (translationStatus === "translated") {
                    return {
                        handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                            yield save(values, "corrected", true);
                        }),
                    };
                }
            })(),
            remove: (() => {
                var _a, _b, _c, _d;
                if (!langId)
                    return undefined;
                if (operationMode === "translator") {
                    if (((_a = data.translationStatus) === null || _a === void 0 ? void 0 : _a[langId]) === "corrected") {
                        return {
                            title: isLastElement
                                ? "翻訳済みに差し戻す"
                                : "翻訳済みに差し戻して次へ",
                            confirm: "翻訳済みに差し戻しますか？",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "translated", true);
                            }),
                        };
                    }
                    else if (((_b = data.translationStatus) === null || _b === void 0 ? void 0 : _b[langId]) === "translated") {
                        return {
                            title: isLastElement
                                ? "未着手に差し戻す"
                                : "未着手に差し戻して次へ",
                            confirm: "未着手に差し戻しますか？",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, null, true);
                            }),
                        };
                    }
                    else {
                        return undefined;
                    }
                }
                else if (operationMode === "corrector") {
                    if (((_c = data.translationStatus) === null || _c === void 0 ? void 0 : _c[langId]) === "corrected") {
                        return {
                            title: isLastElement
                                ? "翻訳済みに差し戻す"
                                : "翻訳済みに差し戻して次へ",
                            confirm: "翻訳済みに差し戻しますか？",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, "translated", true);
                            }),
                        };
                    }
                    else if (((_d = data.translationStatus) === null || _d === void 0 ? void 0 : _d[langId]) === "translated") {
                        return {
                            title: isLastElement
                                ? "未着手に差し戻す"
                                : "未着手に差し戻して次へ",
                            confirm: "未着手に差し戻しますか？",
                            handler: (values) => __awaiter(void 0, void 0, void 0, function* () {
                                yield save(values, null, true);
                            }),
                        };
                    }
                    else {
                        return undefined;
                    }
                }
                else {
                    return undefined;
                }
            })(),
        });
    }, [
        langId,
        operationMode,
        projectId,
        projectData.ignoredReferenceTranslationIds,
        data,
        save,
        onAction,
        splitMode,
        isLastElement,
    ]);
    const { edit, next, remove, schema } = parameter;
    const clickEdit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _j;
        if (edit === null || edit === void 0 ? void 0 : edit.confirm) {
            const result = yield confirm({
                message: (edit === null || edit === void 0 ? void 0 : edit.confirm) || "更新しますか？",
            });
            if (!result)
                return;
        }
        try {
            yield ((_j = edit === null || edit === void 0 ? void 0 : edit.handler) === null || _j === void 0 ? void 0 : _j.call(edit, getValues()));
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "Error while saving script",
                userMessage: "テキスト情報の保存に失敗しました。この問題が繰り返す場合は管理者にお問い合わせください。",
            });
        }
    });
    const hasErrors = Object.keys(formState.errors).length > 0;
    const clickDelete = () => __awaiter(void 0, void 0, void 0, function* () {
        var _k;
        if ((remove === null || remove === void 0 ? void 0 : remove.confirm) !== false) {
            const result = yield confirm({
                message: (remove === null || remove === void 0 ? void 0 : remove.confirm) || "削除しますか？",
            });
            if (!result)
                return;
        }
        try {
            yield ((_k = remove === null || remove === void 0 ? void 0 : remove.handler) === null || _k === void 0 ? void 0 : _k.call(remove, getValues()));
            const path = remove === null || remove === void 0 ? void 0 : remove.path;
            path && navigate(path);
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "Error delete script",
                userMessage: "テキスト情報の削除に失敗しました。この問題が繰り返す場合は管理者にお問い合わせください。",
            });
        }
    });
    const { setBlockNavigation } = (0, standard_1.useBlockNavigation)({
        blockLevel: "browser",
    });
    (0, react_1.useEffect)(() => {
        if (formState.isSubmitSuccessful) {
            setBlockNavigation(false);
            const timer = setTimeout(() => {
                setToast({ status: null, timer: null });
            }, 3000);
            setToast({ status: "success", timer });
            // To reset dirty state
            form.reset(data);
        }
        else if (formState.isSubmitting) {
            if (toast.timer) {
                window.clearTimeout(toast.timer);
            }
            setToast({
                status: "submitting",
                timer: null,
            });
        }
    }, [formState.isSubmitting, formState.isSubmitSuccessful]);
    (0, shortcutHandler_1.useShortcutRegister)("SaveAndNextScript", (0, react_1.useCallback)(() => {
        var _a;
        // scriptDoc.data initially has only scriptId, and later it will be updated with the data from the server.
        // createdAt is a required field, so we can use it to check if the data is ready.
        if (!data.createdAt)
            return;
        isShortcutSaving.current = true;
        (_a = next === null || next === void 0 ? void 0 : next.handler) === null || _a === void 0 ? void 0 : _a.call(next, getValues());
    }, [data, next === null || next === void 0 ? void 0 : next.handler, getValues]));
    // NOTE: copilotでreadOnlyになるとホットキーは無効化されるためここでホットキーを登録
    (0, hooks_2.useHotkeys)([["mod + ArrowRight", () => !isLastElement && (onAction === null || onAction === void 0 ? void 0 : onAction("next"))]], [], isTranslationReadOnly);
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement("div", { className: "tile" },
            react_2.default.createElement("div", { className: "card tile", style: { border: 0 } },
                react_2.default.createElement("div", { className: "card-content", style: { padding: "20px" } },
                    react_2.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, form),
                        react_2.default.createElement("form", { className: "adjust-width-expand", noValidate: true, style: {
                                position: "relative",
                            } },
                            react_2.default.createElement("div", { style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "6px 8px",
                                    borderRadius: "6px",
                                    border: "1px solid #D9D9D9",
                                    backgroundColor: "#FBFBFD",
                                    marginBottom: "20px",
                                } },
                                react_2.default.createElement("span", null,
                                    react_2.default.createElement("span", { style: {
                                            fontWeight: 700,
                                            marginRight: 22,
                                        } }, "ID"),
                                    react_2.default.createElement("span", null, data.scriptId)),
                                react_2.default.createElement("span", null,
                                    "\u672A\u89E3\u6C7A\u30B3\u30E1\u30F3\u30C8\u6570\uFF1A",
                                    numberOfUnresolvedComment)),
                            react_2.default.createElement(schemaComponents_1.Field, { control: control, schema: schema, readOnly: readOnly, key: `field-${langId}-${translationsCleared ? "cleared" : ((_b = data.translations) === null || _b === void 0 ? void 0 : _b[langId]) || "empty"}-${data.text}` }),
                            edit && splitMode === "vertical" && (react_2.default.createElement("div", { style: {
                                    position: "absolute",
                                    bottom: 10,
                                    right: 0,
                                } },
                                react_2.default.createElement(components_1.Button, { type: "button", className: "me-2", onClick: clickEdit }, (edit === null || edit === void 0 ? void 0 : edit.title) || "保存"))),
                            !readOnly && (react_2.default.createElement(react_2.default.Fragment, null,
                                edit && hasErrors && (react_2.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, "\u672A\u5165\u529B\u306E\u9805\u76EE\u304C\u3042\u308A\u307E\u3059\u3002\u4E0A\u306B\u30B9\u30AF\u30ED\u30FC\u30EB\u3057\u3066\u8A72\u5F53\u7B87\u6240\u3092\u4FEE\u6B63\u3057\u3066\u304F\u3060\u3055\u3044")),
                                react_2.default.createElement("div", { style: { marginTop: 20 } },
                                    edit && splitMode === "horizontal" && (react_2.default.createElement(components_1.Button, { type: "button", className: "me-2", onClick: clickEdit }, (edit === null || edit === void 0 ? void 0 : edit.title) || "保存")),
                                    remove && (react_2.default.createElement(components_1.Button, { onClick: clickDelete, type: "button", variant: "danger", className: "me-2" }, remove.title || "削除")))))))))),
        react_2.default.createElement(react_bootstrap_1.ToastContainer, { position: "bottom-end", containerPosition: "fixed", className: "m-4" },
            react_2.default.createElement(react_bootstrap_1.Toast, { show: !!toast.status, onClose: () => setToast((prev) => (Object.assign(Object.assign({}, prev), { status: null }))) },
                react_2.default.createElement(react_bootstrap_1.ToastHeader, null,
                    react_2.default.createElement("strong", { className: "me-auto d-flex align-items-center" }, toast.status === "submitting" ? (react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement(react_bootstrap_1.Spinner, { className: "me-2", animation: "border", role: "status", style: { width: "1rem", height: "1rem" } }),
                        "\u30BB\u30FC\u30D6\u4E2D")) : (react_2.default.createElement(react_2.default.Fragment, null,
                        react_2.default.createElement("i", { className: "mdi mdi-check-circle-outline me-2 text-success", style: { width: "1rem", height: "1rem" } }),
                        "\u30BB\u30FC\u30D6\u6210\u529F")))),
                react_2.default.createElement(react_bootstrap_1.ToastBody, null, toast.status === "submitting"
                    ? "変更内容を保存しています..."
                    : "変更内容を保存しました。")))));
};
exports.default = ScriptItemForm;
